import * as React from 'react';

import { Box } from '@mui/material';

import { useModal } from 'mui-modal-provider';

import PageTitle from '../../components/PageTitle/PageTitle';
import ListContent from './components/ListContent';
import { ManageContentTipsDialogV2 } from '../../components/Dialogs/ManageContentTipsV2/ManageContentTipsDialogV2';

const ReservationContent: React.FC = () => {
  const { showModal } = useModal();

  const handleClickDesc = React.useCallback<React.MouseEventHandler<HTMLAnchorElement>>(
    (e) => {
      e.preventDefault();

      showModal(ManageContentTipsDialogV2);
    },
    [showModal],
  );

  return (
    <Box sx={{ backgroundColor: 'white', flex: 1, p: 4 }}>
      <PageTitle
        title='Content'
        sideComponent={
          <Box
            component='a'
            href='#'
            onClick={handleClickDesc}
            sx={{ fontSize: '0.8rem', color: 'black' }}
          >
            What is content?
          </Box>
        }
      />

      <Box mt={2}>
        <ListContent />
      </Box>
    </Box>
  );
};

export default ReservationContent;
